import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0011',
    ecrans: ['00-2']
});
